<template>
    <div class="sci__management">
        <div class="sci__management-header">
            <h3 class="dashboard__title">SCI Management</h3>
            <h5 class="sci__management-title"> <i class="far fa-database"></i> Opt-Outs Database </h5>
            <p class="sci__management-subtitle">Configure the preferences for the Opt-Out form</p>
        </div>
        <div class="sci__management-search">
            <div class="row">
                <div class="col-xl-10">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>
                                <i class="far fa-search"></i> Search by Student Number or Name
                            </label>
                        </div>
                        <div class="col-lg-8">
                            <input class="form-control form-control-sm" type="search" ref="searchTerm" id="searchTerm"
                                name="searchTerm" placeholder="Search" aria-label="Search" @keyup.enter="searchUsers()">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>
                                <i class="far fa-calendar-alt"></i> Select an Academic Year
                            </label>
                        </div>
                        <div class="col-lg-8">
                            <div v-if="filesFlag" class="input-group input-group-sm">
                                <select class="form-control" id="searchYear" name="searchYear" ref="searchYear">
                                    <option v-for="item in files" :value="item.yearStart" :key="item.file">
                                        {{ item.label }}
                                    </option>
                                </select>
                            </div>
                            <div v-else class="text-primary">
                                <i class="far fa-bells"></i>
                                Search is currently unavailable due no data! If there are any questions or concerns,
                                <b>please contact your system administrator.</b>
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <div v-if="alert.message && alert.type" class="search__alert font-weight-bold mb-2">
                            <div v-if="alert.type ==='success'" class="text-success">
                                <i class="far fa-check"></i> {{ alert.message }}
                            </div>
                            <div v-else-if="alert.type ==='warning'" class="text-warning">
                                <i class="far fa-info"></i> {{ alert.message }}
                            </div>
                        </div>
                        <button class="btn btn-sm btn-outline-primary mr-2" type="button" id="submitSearch"
                            @click="searchUsers()"><i v-if="!alert.status" class="far fa-search"></i><i v-else
                                class="far fa-spinner fa-spin"></i> Search
                        </button>
                        <button class="btn btn-sm btn-outline-danger" type="button" id="clearSearch"
                            @click="clearSearch()"><i class="far fa-times"></i>
                            Clear</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="user" class="sci__management-form">
            <div class="row">
                <div class="col-xl-10">
                    <hr>
                    <h5 class="sci__management-subtitle"><i class="far fa-user-edit"></i> Edit Opt-Out form for <b>{{ commonname }}</b></h5>
                    <div class="sci__management-form--edit">
                        <SCIform :user="user" :admin="admin"></SCIform>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="users.length > 0 && !user" class="sci__management-result">
            <hr>
            <h5 class="sci__management-title">Search Results</h5>
            <div class="row">
                <div class="col-xl-10">
                    <ul class="list-group list-group-flush">
                        <li v-for="user in users" :key="user.username" class="list-group-item">{{ user.commonname }}
                            ({{ user.username }}) <span class="float-right"><a href="javascript:void(0)"
                                    @click="viewUserForm(user)"><i class="far fa-folder-open"></i> View</a></span></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SCIform from '../Form/v1/Form';

export default {
    name: 'admin-management',
    props: {
        files: {
            type: Array
        }
    },
    components: {
        SCIform
    },
    data() {
        return {
            admin: true,
            alert: {
                message: '',
                status: false,
                type: ''
            },
            commonname: '',
            filesFlag: false,
            user: '',
            users: []
        }
    },
    methods: {
        clearSearch() {
            // Reset search term
            this.$refs.searchTerm.value = '';

            // Reset users
            this.user = '';
            this.commonname = '';
            this.users = [];

            // Reset alert flag
            this.alert.message = '';
            this.alert.status = false;
            this.alert.type = '';
        },
        hasExports() {
            if (this.files && this.files.length > 0) {
                this.filesFlag = true;
            } else {
                this.filesFlag = false;
            }
        },
        searchUsers() {
            const that = this;
            const formData = new FormData();
            let URL = 'https://HOSTNAME/cgi-bin/mkvn-sci-backend/controller.sci.pl?adminSearch';
            URL = URL.replace("HOSTNAME", location.hostname);

            // Reset alert flag
            this.alert.message = '';
            this.alert.status = true;
            this.alert.type = '';
            this.user = '';
            this.commonname = '';

            // Add key value pair to formdata
            if (this.$refs.searchTerm) {
                formData.append('searchTerm', this.$refs.searchTerm.value);
            } else {
                formData.append('searchTerm', '');
            }

            if (this.$refs.searchYear) {
                formData.append('yearStart', this.$refs.searchYear.value);
            }

            // POST request
            fetch(URL, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    // Handle success response
                    if (json.result.match(/OK/i)) {
                        // Store users
                        that.users = json.data;

                        // Set alert
                        that.alert.status = false;
                        that.alert.type = 'success';
                    } else {
                        // Reset users
                        that.users = [];

                        // Set alert
                        that.alert.status = false;
                        that.alert.type = 'warning';
                    }

                    // Set alert message
                    that.alert.message = json.message;
                    that.alert.message = that.alert.message.charAt(0).toUpperCase() + that.alert.message.slice(1) + '.';
                })
                .catch(function (error) {
                    // Reset users
                    that.users = [];

                    // Set alert
                    this.alert.message = error;
                    this.alert.status = false;
                    this.alert.type = 'warning';
                })
        },
        viewUserForm(user) {
            const that = this;
            const formData = new FormData();
            let URL = `https://HOSTNAME/cgi-bin/mkvn-sci-backend/controller.sci.pl?adminGetRecord&recordID=RECORDID&yearStart=${user.academicYearStart}`;
            URL = URL.replace("HOSTNAME", location.hostname);
            URL = URL.replace("RECORDID", user.recordID);

            // Store user data
            this.commonname = user.commonname;

            // GET request
            fetch(URL, {
                    method: 'GET'
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    // Reset users
                    that.users = [];

                    // Handle success response
                    if (json.result.match(/OK/i)) {
                        // Set user
                        that.user = json;
                    } else {
                        // Set warning alert
                        that.alert.type = 'warning';
                        that.alert.message = 'The selected user\'s SCI form could be retrieved. Please contact your system administrator';
                    }
                })
                .catch(function (error) {
                    // Set warning alert
                    that.alert.type = 'warning';
                    that.alert.message = 'The selected user\'s SCI form could be retrieved. Please contact your system administrator';
                })
        }
    },
    mounted() {
        // Initial exports file check
        this.hasExports();
    }
}
</script>

<style scoped>
.sci__management-form--edit {
    border: 1px solid rgba(0,0,0,.125);
    border-color: #d7dfe3;
    border-radius: 4px;
    -webkit-box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.05);
    padding: 1rem;
}

.sci__management-title {
    color: #455a64;
    font-weight: 400;
}

.sci__management-subtitle {
    font-weight: 300;
    margin-bottom: 15px;
    color: #99abb4;
}
</style>
